import React from "react";
import productimg from "../../Image/Untitled design - 2025-01-15T083142.916.png";
import productimg2 from "../../Image/Untitled design - 2025-01-15T054012.631 1 (1).png";
import productimg3 from "../../Image/Untitled design - 2025-01-15T053402.987 1.png";
import productimg4 from "../../Image/Untitled design - 2025-01-15T055702.752 1.png";

import productimg5 from "../../Image/Untitled design - 2025-01-15T065656.041 1.png";
import productimg6 from "../../Image/Untitled design (2).png";

import img1 from "../../Image/Rectangle 34625569.png";
import "../Home.css";
import { Link, Navigate, useNavigate } from "react-router-dom";

function Advvaries() {
    const navigate = useNavigate();
    const backnavi = () => {
        navigate(-1);
    };

    const handle = (product) => {
        window.top.location.href = `https://www.zumwax.com/products/${product}`;
    }; 
    return (
        <div>
            <div className="container-fluid home-banner-div1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div>
                                <img src={img1} className="img-fluid" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7 home-banner-col2-div1">
                            <div className="home-banner-col2-text11">
                                <h1>Optimal wax found! Time to shred!</h1>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="home-banner-btn1 ">
                                            <Link onClick={() => handle("iron-on-ski-snowboard-nordic-base-prep-wax")}>
                                            
                                                <div className="product-card-div1 ">
                                                    <div className="product-image-div1">
                                                        <img src={productimg} className="base-image1" />
                                                    </div>
                                                    <div className="product-text-div1">
                                                        <h2>Base Prep Wax</h2>
                                                        <p>
                                                            Designed to deliver elite-level performance in
                                                            competitions across all snow sports
                                                        </p>
                                                        <h3>View Product</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="home-banner-btn1 ">
                                            <Link onClick={() => handle("iron-on-ski-snowboard-nordic-cross-country-wax")}>
                                                <div className="product-card-div1 ">
                                                    <div className="product-image-div1">
                                                        <img src={productimg2} className="" />
                                                    </div>
                                                    <div className="product-text-div1">
                                                        <h2>Universal Iron On Wax</h2>
                                                        <p>Universal - All Conditions</p>
                                                        <h3>View Product</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="home-banner-btn1 ">
                                            <Link onClick={() => handle("rub-on-ski-snowboard-nordic-cross-country-wax")}>
                                                <div className="product-card-div1 ">
                                                    <div className="product-image-div1">
                                                        <img src={productimg3} className="" />
                                                    </div>
                                                    <div className="product-text-div1">
                                                        <h2>Universal Rub On Wax</h2>
                                                        <p>Universal - All Conditions</p>
                                                        <h3>View Product</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="home-banner-btn1 ">
                                            <Link onClick={() => handle("all-natural-biodegradable-ski-racing-wax")}>
                                                <div className="product-card-div1 ">
                                                    <div className="product-image-div1">
                                                        <img src={productimg4} className="base-image1" />
                                                    </div>
                                                    <div className="product-text-div1">
                                                        <h2>All Natural Biodegradable Ski Racing Wax  </h2>
                                                        <p>Universal - All Conditions</p>
                                                        <h3>View Product</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="home-banner-btn1 ">
                                            <Link onClick={() => handle("glacier-graphite-iron-on-wax-racing-glide-wax-ski-snowboard-nordic-cross-country-perfect-for-dirty-abrasive-snow")}>
                                                <div className="product-card-div1 ">
                                                    <div className="product-image-div1">
                                                        <img src={productimg6} className="warm-moly-img" />
                                                    </div>
                                                    <div className="product-text-div1">
                                                        <h2>Glacier Graphite Iron On Wax</h2>
                                                        <p>
                                                            Air Temperature Range: 10°C to -30°C or 50°F to -22°F / Snow Temperature Range: 0°C to -30°C or 32°F to -22°F
                                                        </p>
                                                        <h3>View Product</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div>
                                    <Link to="/expertvariesspeed">
                                        <div className="next-btn3">
                                            Do you want to significantly Improve your speed?
                                        </div>
                                    </Link>
                                </div>

                                <div className="next-btn-div1">
                                    <Link onClick={backnavi}>
                                        <div className="next-btn1">
                                            <svg
                                                class="mr-3"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="11"
                                                height="16"
                                                viewBox="0 0 11 16"
                                                fill="none"
                                            >
                                                <path
                                                    d="M9 14L3 8L9 2"
                                                    stroke="rgba(0, 0, 0, 0.80)"
                                                    stroke-width="4"
                                                    stroke-linecap="round"
                                                />
                                            </svg>{" "}
                                            Back
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Advvaries;
